<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      Add Answer
    </span>

    <!-- <span class="ttmodal__title" *ngIf="QuestionTypeId==4 || QuestionTypeId==5>">
      Add Answer
    </span> -->
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">
    <div *ngIf="QuestionTypeId==2 || QuestionTypeId==1">
      <ul style="font-size: 18px;">
        <li *ngFor="let answer of AnswerList">
          <label>
            <input type="radio" name="answer" [value]="answer.Name" [checked]="answer.UserSelect"
              (change)="onAnswerSelected(answer)">
            {{ answer.Name }}
          </label>
        </li>
      </ul>
    </div>
    <div *ngIf="QuestionTypeId==3">
      <ul style="font-size: 18px;">
        <li *ngFor="let answer of AnswerList">
          <label>
            <input type="checkbox" [checked]="answer.UserSelect" (change)="onAnswerSelected(answer)">
            {{ answer.Name }}
          </label>
        </li>
      </ul>
    </div>

    <div *ngIf="QuestionTypeId==4">
      <ng-container *ngFor="let answer of AnswerList">
        <input type="text"  (change)="onAnswerSelected(answer)" [(ngModel)]="answer.Name">
    </ng-container>
    </div>
    <div *ngIf="QuestionTypeId==5">

      <ng-container *ngFor="let answer of AnswerList">
        <!--<input type="number" (change)="onAnswerSelected(answer)" [(ngModel)]="answer.Name">-->
        <div style="display: flex; gap: 25px; justify-content: space-between; flex-direction: column;">
          <div>
            <span>0% Worn: {{ startWorn | number: '1.' + noOfDecimal + '-' + noOfDecimal }}</span>
          </div>
          <div>
            <span>
              100% Worn: {{ endWorn | number: '1.' + noOfDecimal + '-' + noOfDecimal }}
            </span>
          </div>
          <div>
            <span>
              # of Decimal Places: {{ noOfDecimal }}
            </span>
          </div>
          <div>
            <div style="margin-right: 25px;">
              <mat-form-field class="header-form-full-width">
                <input placeholder="Answer" matInput type="number" [min]="startWorn" [max]="endWorn" (invalid)="onInvalid(answerInput)"
                       (change)="onAnswerSelected(answer)" (blur)="formatToDecimals(answer)" [(ngModel)]="answer.Name" class="get-Input" (input)="onDecimalInput($event)">
              </mat-form-field>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="ttmodal__footer" style="display: flex; justify-content: space-between;">
    <button mat-raised-button (click)="onNoClick()"> Cancel</button>
    <button mat-raised-button color="warn" (click)="AddupdateAdditionalObsAnswer()">
      <span class="material-icons button__icon">check</span><span class="button__text">Save </span></button>
  </div>
</div>
